export const enum ConvertCloudyToClassicSource {
    contextMenu,
    sharingTip,
}
